import { useDeferredValue, useState } from 'react';

import { CampaignListSort, CampaignStatus, useCampaigns } from '@/entities/campaign';

export type CampaignListFilter = 'all' | CampaignStatus;

export function useCampaignList() {
  const [searchQuery, setSearchQuery] = useState('');
  const deferredSearchQuery = useDeferredValue(searchQuery.trim().toLowerCase());
  const [statusFilter, setStatusFilter] = useState<CampaignListFilter>('all');
  const [sortOption, setSortOption] = useState<CampaignListSort>(CampaignListSort.ENDING_SOON);
  const campaignsQuery = useCampaigns({
    name: deferredSearchQuery || undefined,
    sort: sortOption,
    status: statusFilter === 'all' ? undefined : statusFilter,
  });

  const campaigns = campaignsQuery.data?.pages.flatMap((pageData) => pageData.items) ?? [];
  const hasActiveFilters = statusFilter !== 'all' || deferredSearchQuery.length > 0;
  const isEmpty = campaigns.length === 0 && !hasActiveFilters;
  const isFilteredEmpty = campaigns.length === 0 && hasActiveFilters;

  return {
    campaignsQuery,
    isEmpty,
    isFilteredEmpty,
    filters: {
      deferredSearchQuery,
      searchQuery,
      setSearchQuery,
      setSortOption,
      setStatusFilter,
      sortOption,
      statusFilter,
    },
  };
}
